import React from "react"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  RedditShareButton,
  RedditIcon,
} from "react-share"

const ShareButtons = ({ title, url, twitterHandle, tags, image }) => {
  return (
    <div className="text-center p-2">
      <h4>Share this Post</h4>
      <FacebookShareButton
        url={url}
        imageURL={image}
        quote={title}
        className="mr-2"
      >
        <FacebookIcon size={40} round={true} />
      </FacebookShareButton>

      <TwitterShareButton
        onClick={e => {
          e.preventDefault()
          trackCustomEvent({
            category: "Special Campaign Button",
            action: "Click",
            label: "Post shared on Twitter",
            value: 1,
          })
        }}
        url={url}
        title={title}
        media={image}
        hashtags={tags}
        via={twitterHandle}
        className="mr-2"
      >
        <TwitterIcon size={40} round={true} />
      </TwitterShareButton>

      <LinkedinShareButton
        url={url}
        title={title}
        media={image}
        className="mr-2"
        onClick={e => {
          e.preventDefault()
          trackCustomEvent({
            category: "Special Campaign Button",
            action: "Click",
            label: "Post shared on LinkedIn",
            value: 1,
          })
        }}
      >
        <LinkedinIcon size={40} round={true} />
      </LinkedinShareButton>

      <RedditShareButton
        url={url}
        title={title}
        media={image}
        className="mr-2"
        onClick={e => {
          e.preventDefault()
          trackCustomEvent({
            category: "Special Campaign Button",
            action: "Click",
            label: "Post shared on Reddit",
            value: 1,
          })
        }}
      >
        <RedditIcon size={40} round={true} />
      </RedditShareButton>

      <WhatsappShareButton
        url={url}
        title={title}
        media={image}
        className="mr-2"
        onClick={e => {
          e.preventDefault()
          trackCustomEvent({
            category: "Special Campaign Button",
            action: "Click",
            label: "Post shared on WhatsApp",
            value: 1,
          })
        }}
      >
        <WhatsappIcon size={40} round={true} />
      </WhatsappShareButton>
    </div>
  )
}
export default ShareButtons
